import { render, staticRenderFns } from "./ValidarBodyModal.vue?vue&type=template&id=e73ca79a&scoped=true&"
import script from "./ValidarBodyModal.vue?vue&type=script&lang=ts&"
export * from "./ValidarBodyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ValidarBodyModal.vue?vue&type=style&index=0&id=e73ca79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73ca79a",
  null
  
)

export default component.exports